import React from "react";
import NavbarComponent from "./navbar";

import styled from 'styled-components';

const StyledContainer = styled.div`
  position: sticky;
	top: 0;
	z-index: 9999;
	background-color: #0073a6;
`;

const NavbarHome = () => {
	return (
		<StyledContainer>
			<NavbarComponent />
		</StyledContainer>
	)
}

export default NavbarHome;